/* eslint-disable */

class RequestSample {
  constructor(button) {
    this.button = button;
    this.isProcessing = false;

    this.pageContainer = document.getElementById('PageContainer');
    this.cartAction = this.pageContainer?.dataset.cartAction;
    this.cartType = this.pageContainer?.dataset.cartType;

    this.eventBus = globalThis.eventBus;
    this.routes = globalThis.routes;

    this.sampleVariantId = parseInt(button.dataset.sampleVariantId || '', 10);
    this.sampleProductId = parseInt(button.dataset.sampleProductId || '', 10);

    this.sampleProductIdRetail = parseInt(button.dataset.sampleProductIdRetail || '', 10) || null;
    this.sampleProductIdTrade = parseInt(button.dataset.sampleProductIdTrade || '', 10) || null;

    this.wallpaperSampleProductId = parseInt(button.dataset.wallpaperSampleProductId || '', 10) || null;
    this.fabricSampleProductId = parseInt(button.dataset.fabricSampleProductId || '', 10) || null;

    this.limit = parseInt(button.dataset.sampleLimit || '0', 10) || 0;
    this.errorTarget = button.closest('[data-request-sample-wrapper]')?.querySelector('[data-request-sample-error]');

    this.onClickBound = this.onClick.bind(this);
    button.addEventListener('click', this.onClickBound);
  }

  async onClick(event) {
    event.preventDefault();

    if (this.isProcessing) return;
    if (!this.sampleVariantId) return;

    this.clearError();

    this.isProcessing = true;
    this.setLoading(true);

    try {
      if (this.limit > 0) {
        const withinLimit = await this.checkLimit();
        if (!withinLimit) {
          this.showError(this.button.dataset.sampleLimitMessage || 'Sample limit reached.');
          return;
        }
      }

      const response = await this.addSampleToCart();
      if (!response.ok) {
        let err = 'Failed to add sample to cart.';
        try {
          const json = await response.json();
          err = json?.description || json?.message || err;
        } catch (_) {}
        this.showError(err);
        return;
      }

      if (this.cartType === 'drawer') {
        const responseJson = await response.json();
        this.eventBus?.emit('update:cart:drawer', responseJson);
      }

      this.afterAddToCart();
      this.updateCartCountIndicator();
    } catch (e) {
      console.error(e);
      this.showError('Failed to add sample to cart.');
    } finally {
      this.isProcessing = false;
      this.setLoading(false);
    }
  }

  async checkLimit() {
    try {
      const cart = await this.getCart();
      if (!cart || !Array.isArray(cart.items)) return true;

      const sampleProductIds = [this.wallpaperSampleProductId, this.fabricSampleProductId, this.sampleProductId]
        .concat([this.sampleProductIdRetail, this.sampleProductIdTrade])
        .filter(Boolean);

      const currentSampleCount = cart.items
        .filter((item) => sampleProductIds.includes(item.product_id))
        .reduce((sum, item) => sum + (item.quantity || 0), 0);

      return currentSampleCount + 1 <= this.limit;
    } catch (e) {
      // If we can't validate limit, fail open to avoid blocking sales.
      return true;
    }
  }

  async getCart() {
    const url = '/cart.js';
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) return null;
    return await res.json();
  }

  addSampleToCart() {
    const url = this.routes?.cart_add_url || '/cart/add.js';

    const payload = {
      items: [
        {
          id: this.sampleVariantId,
          quantity: 1,
        },
      ],
    };

    const properties = {};

    const forHandle = this.button.dataset.forProductHandle;
    const forTitle = this.button.dataset.forProductTitle;
    const forType = this.button.dataset.forProductType;
    const forVariantId = this.button.dataset.forVariantId;
    const forVariantImage = this.button.dataset.forVariantImage;
    const forOption1Name = this.button.dataset.forVariantOption1Name;
    const forOption1Value = this.button.dataset.forVariantOption1Value;

    if (forHandle) properties['_sample_for_handle'] = forHandle;
    if (forTitle) properties['_sample_for_title'] = forTitle;
    if (forType) properties['_sample_for_type'] = forType;
    if (forVariantId) properties['_sample_for_variant_id'] = forVariantId;
    if (forVariantImage) properties['_sample_image'] = forVariantImage;
    if (forOption1Name) properties['_sample_for_option1_name'] = forOption1Name;
    if (forOption1Value) properties['_sample_for_option1_value'] = forOption1Value;

    // Checkout-friendly (non-hidden) properties: these can surface in checkout/order summary.
    if (forTitle) {
      const typeLabel = (forType || '').trim();
      const sampleKey = (`SAMPLE ${typeLabel}`.trim()).toUpperCase();
      properties[sampleKey] = forTitle;
    }

    if (forOption1Value) {
      const optionLabel = (forOption1Name || 'Colour').trim() || 'Colour';
      properties[optionLabel] = forOption1Value;
    }

    // No checkout-visible image property: checkout thumbnails cannot be overridden via theme.

    if (Object.keys(properties).length) {
      payload.items[0].properties = properties;
    }

    if (this.cartType === 'drawer') {
      payload.sections = 'cart-drawer';
    }

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  afterAddToCart() {
    if (this.cartAction === 'show_added_message') {
      this.showAddedMessage();
      return;
    }

    if (this.cartType === 'drawer' && this.cartAction === 'go_to_or_open_cart') {
      this.eventBus?.emit('open:cart:drawer', { scrollToTop: true });
      return;
    }

    window.location = this.routes?.cart_url || '/cart';
  }

  async updateCartCountIndicator() {
    try {
      const cart = await this.getCart();
      if (cart) {
        window.wetheme?.updateCartCount?.(cart);
      }
    } catch (_) {}
  }

  showAddedMessage() {
    const originalText = this.button.textContent;
    const addedText = this.button.dataset.sampleAddedLabel || 'Added';
    this.button.textContent = addedText;
    window.setTimeout(() => {
      this.button.textContent = originalText;
    }, 2000);
  }

  setLoading(isLoading) {
    this.button.toggleAttribute('disabled', isLoading);
    this.button.classList.toggle('is-loading', isLoading);
  }

  showError(message) {
    if (this.errorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.classList.remove('hidden');
    }
  }

  clearError() {
    if (this.errorTarget) {
      this.errorTarget.textContent = '';
      this.errorTarget.classList.add('hidden');
    }
  }
}

function initRequestSample() {
  document.querySelectorAll('[data-request-sample]').forEach((button) => {
    if (button.dataset.requestSampleInit === 'true') return;
    button.dataset.requestSampleInit = 'true';
    new RequestSample(button);
  });
}

// Initialize on load.
initRequestSample();

// Re-init when Flow swaps DOM on variant/section updates.
globalThis.eventBus?.on('variant:updated', initRequestSample);
globalThis.eventBus?.on('render:cart:drawer', initRequestSample);
